import MyCollapse from 'components/Collapse';
import Spin from 'components/Spin';
import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import shoppingProductService from 'v2/services/shopping/product';

import type { IShoppingProduct } from 'v2/interfaces/shopping';

import useStyle from '../styles';

const ProducerContact = ({ shopping }: { shopping: IShoppingProduct }) => {
  const classes = useStyle();

  const [loadingProducerData, setLoadingProducerData] = useState<boolean>(false);
  const [producerData, setProducerData] = React.useState<IShoppingProduct | null>(null);

  const handleClickProducerData = useCallback(async (invoiceId: string) => {
    setLoadingProducerData(true);
    shoppingProductService.producerContact(invoiceId).subscribe((res) => {
      setProducerData(res.data);
      setLoadingProducerData(false);
    }, toast.error);
  }, []);

  return (
    <MyCollapse title='Contato com Produtor' onClick={() => handleClickProducerData(shopping.invoice_id)} arrow>
      {loadingProducerData && <Spin />}

      {producerData && !loadingProducerData && (
        <div className={classes.sender}>
          {producerData.producer.name && (
            <div className='data'>
              <span>Nome:</span> {producerData.producer.name}
            </div>
          )}
          {producerData.producer.email && (
            <div className='data'>
              <span>E-mail:</span> {producerData.producer.email}
            </div>
          )}
          {producerData.producer.phone && (
            <div className='data'>
              <span>Telefone:</span> {producerData.producer.phone}
            </div>
          )}
          {producerData.producer.address && (
            <div className='data'>
              <span>Endereço:</span> {`${producerData.producer.address}`}
            </div>
          )}
        </div>
      )}
    </MyCollapse>
  );
};

export default ProducerContact;
